
import { useEffect, useState } from 'react';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import { useIntl } from "react-intl";

import CustomTable from 'components/table';
import { TableEditButton, DeleteButton, TableButtonGroup } from 'components/button';
import { masterPaginationServices, tableInitialState, } from 'utils/constants';
import { getTableParams } from 'utils/global';
import { RootReducerState } from 'utils/types';
import { getMasterPaginationData } from 'redux/actions';
import PageLayout from 'layouts/PageLayout';
import Form from './Form';
import { services } from 'redux/services';
import { useToastMessage } from 'hooks';
import { bannerColumns } from 'utils/constants/tableColumn/column';

const Index: React.FC = () => {
    const { formatMessage } = useIntl();
    const dispatch = useDispatch();
    const { toastMessage } = useToastMessage();

    const [tableState, setTableState] = useState(tableInitialState);
    const [deleteLoading, setDeleteLoading] = useState(false);
    const [drawer, setDrawer] = useState(false);
    const [selectedRow, setSelectedRow] = useState(null);

    const { bannerData, loading } = useSelector(
        ({ masterPaginationReducer }: RootReducerState) => ({
            bannerData: masterPaginationReducer[masterPaginationServices.banner].data,
            loading: masterPaginationReducer[masterPaginationServices.banner].loading,
        }),
        shallowEqual
    );

    const { items, count } = bannerData;

    useEffect(() => {
        onApiCall();
    }, [tableState]);

    function onApiCall() {
        const params = getTableParams(tableState);
        dispatch(getMasterPaginationData(masterPaginationServices.banner, params));
    }

    const columnAction = {
        label: formatMessage({ id: "action" }),
        name: "",
        options: {
            customBodyRender: (_: any, tableMeta: any) => {
                return (
                    <TableButtonGroup>
                        <TableEditButton
                            tooltipLabel="Edit Banner"
                            onClick={() => handleRowClick(items[tableMeta.rowIndex])}
                        />
                        <DeleteButton
                            onDelete={() => onDeleteData(items[tableMeta.rowIndex])}
                        />
                    </TableButtonGroup>
                )
            }
        }
    }

    function handleRowClick(rowData: any) {
        setSelectedRow(rowData);
        setDrawer(true);
    }

    function handleCreate() {
        setSelectedRow(null);
        setDrawer(true);
    }

    function onDeleteData(data: any) {
        const params = { id: data.id };
        setDeleteLoading(true);
        services.deleteBanner(params)
            .then((res: any) => {
                setDeleteLoading(false);
                onApiCall();
                toastMessage(formatMessage({ id: "delete-message" }));
            })
            .catch((err) => {
                setDeleteLoading(false);
                toastMessage(err?.data?.message ? err?.data?.message : formatMessage({ id: "opps-error-message" }), 'error');
            })
    }

    return (
        <PageLayout title={formatMessage({ id: "banner" })} onCreate={handleCreate}>
            <CustomTable
                columns={[...bannerColumns(formatMessage), columnAction]}
                tableData={items}
                tableState={tableState}
                itemsCount={count}
                setTableState={setTableState}
                loading={loading || deleteLoading}
            />

            {drawer && (
                <Form
                    refreshData={onApiCall}
                    open={drawer}
                    closeModal={() => setDrawer(false)}
                    formMode={!selectedRow ? 'create' : 'update'}
                    selectedData={selectedRow}
                    headerText={!selectedRow ? formatMessage({ id: "create-banner" }) : formatMessage({ id: "update-banner" })}
                />
            )}
        </PageLayout>
    )
}

export default Index;
